/**
 * Colours of the ★ map rules and team play overlays, the map bar's rules
 * segments and the first-entry coach mark (tmp design v3, `TH`). The paper,
 * ink, olive, brass and blood values mirror the theme tokens (lib/themeVars);
 * amber, good, bad and the scrims exist only here, for SVG and icon colour
 * props that cannot read a CSS variable.
 */
export type OverlayTheme = 'light' | 'dark'

export interface OverlayPalette {
  paper: string
  paperUp: string
  ink: string
  inkSoft: string
  olive: string
  brass: string
  blood: string
  amber: string
  good: string
  bad: string
  /** The pause-screen dim over the board. */
  scrim: string
  /** The legend sheet. */
  sheet: string
  /** A hovered or isolated legend row. */
  rowHighlight: string
  /** The coach mark's lighter dim. */
  coachScrim: string
}

export const OVERLAY_PALETTE: Record<OverlayTheme, OverlayPalette> = {
  light: {
    paper: '#f4ecd3', paperUp: '#e8e2c8', ink: '#18170f', inkSoft: '#6b5b3e', olive: '#4a5a2a',
    brass: '#b8893a', blood: '#a01818', amber: '#b45309', good: '#2f7d32', bad: '#b3261e',
    scrim: 'rgba(34,30,16,0.64)', sheet: 'rgba(244,236,211,0.95)', rowHighlight: 'rgba(184,137,58,0.18)',
    coachScrim: 'rgba(34,30,16,0.45)',
  },
  dark: {
    paper: '#2c3520', paperUp: '#232a18', ink: '#e6e1c4', inkSoft: '#8a8c6e', olive: '#8aa14a',
    brass: '#d9a85a', blood: '#e0463f', amber: '#e39b3c', good: '#8fd16a', bad: '#ff7f6e',
    scrim: 'rgba(6,8,3,0.72)', sheet: 'rgba(35,42,24,0.95)', rowHighlight: 'rgba(217,168,90,0.16)',
    coachScrim: 'rgba(6,8,3,0.57)',
  },
}

export function overlayPalette(theme: string | undefined): OverlayPalette {
  return OVERLAY_PALETTE[theme === 'dark' ? 'dark' : 'light']
}
